import { useState, useRef } from "react";
// svg images
import CloseIcon from "./svg/CloseIcon";
import OpenIcon from "./svg/OpenIcon";

interface FaqBoxProps {
  open?: boolean;
  answer: any;
  question: string;
  classNames?:string
}

const FaqBox: React.FC<FaqBoxProps> = ({ open, answer, question,classNames="" }) => {
  const [isOpen, setIsOpen] = useState(open ? true : false);
  const [whatHeight, setWhatHeight] = useState(open ? "19.4rem" : "0");
  const curreneHeight: any = useRef<HTMLHeadingElement>(null);

  const checkIsOpen = () => {
    setWhatHeight(isOpen === true ? "0px" : `${curreneHeight.current.scrollHeight}px`);
    setIsOpen(!isOpen);
  };

  return (
    <div className={`faq-box__card ${classNames}`}>
      <p className="faq-box__card--ask">
        <span onClick={checkIsOpen}>
          <i></i>
          {question}
        </span>
        <i className="faq-box__card--ask-icon" onClick={checkIsOpen}>
          {isOpen ? <CloseIcon /> : <OpenIcon />}
        </i>
      </p>
      {/* ${!isOpen ? "d-none" : ""} */}
      <div
        ref={curreneHeight}
        style={{ maxHeight: `${whatHeight}`, overflow: "hidden", transition: `all .4s ease` }}
      >
        <div className={`faq-box__card--answer`}>
          {answer.map((item: any, index: any) => {
            return <p key={index}>{item}</p>;
          })}
        </div>
      </div>
    </div>
  );
};

export default FaqBox;
